const createNameRegExp = (name: string) => new RegExp(`(^| )${name}=([^;]+)`);

export const getCookie = (name: string) => {
  const match = document.cookie.match(createNameRegExp(name));

  return (match ?? [])[2];
};
